import React from "react";

import { RowRenderer } from "src/features/forms/components/RowRenderer";
import { FieldsetData } from "src/features/forms/types";

export const FieldsetRenderer: React.FunctionComponent<FieldsetData> =
	React.memo(({ rows }) => (
		<>
			{rows.map((props, key) => (
				<RowRenderer key={key} {...props} />
			))}
		</>
	));
